import {
  currentMonth,
  currentYear,
  validateExpiration,
  validateFullYear,
  validateMonth,
} from "cc-tools/expiration-validator";

import {
  ChexFieldNames,
  ChexNestedFormValue,
} from "checkout-query-client/types/chex-form-fields";

export const isValidExpiration = () => (value: string) => {
  return validateExpiration(value);
};

export const isValidMonthExpiration = () => (month: string) => {
  return validateMonth(month);
};

export const isValidYearExpiration = () => (year: string) => {
  return validateFullYear(year);
};

export const isValidMonthForCurrentYear =
  (fieldToCheck: ChexFieldNames, formId?: string) =>
  (value: string, values: ChexNestedFormValue) => {
    if (!formId) return;

    const year = values[formId][fieldToCheck];

    if (!year) {
      return true;
    }

    const monthAsInt = parseInt(value);
    const yearAsInt = parseInt(year);

    if (currentYear < yearAsInt) {
      return true;
    }

    return currentYear === yearAsInt && currentMonth <= monthAsInt;
  };

export const isValidYearForCurrentMonth =
  (fieldToCheck: ChexFieldNames, formId?: string) =>
  (value: string, values: ChexNestedFormValue) => {
    if (!formId) return;

    const month = values[formId][fieldToCheck];

    if (!month) {
      return true;
    }

    const monthAsInt = parseInt(month);
    const yearAsInt = parseInt(value);

    if (currentYear < yearAsInt) {
      return true;
    }

    return currentYear === yearAsInt && currentMonth <= monthAsInt;
  };
